<template>
  <div>
    <div v-if="showProductsToFix">
      <v-row justify="center">
        <v-col>
          <h2 class="error--text text-center">
            <v-icon color="error"> mdi-alert-box</v-icon> Cannot upload the
            folowing products.
          </h2>
          <p class="basic--text text-center">
            Please review the products and fix the details if neccessary.
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-data-table
            dense
            :items="products"
            :headers="headers"
            :single-expand="true"
            :expanded.sync="expanded"
            show-expand
            :footer-props="{
              'items-per-page-options': [15, 50, 100, 150, 200],
            }"
          >
            <template v-slot:top>
              <v-row class="pb-2">
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-btn color="accent" @click="refreshData"
                    >Refresh <v-icon>mdi-refresh</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </template>
      
            <template  v-slot:[`item.Photos`]="{ item }">
              <td v-if="item.Photos">
                <v-card style="max-width: 50px" flat>
                  <expandable-image :src="item.Photos[0]"> </expandable-image>
                </v-card>
              </td>
            </template>
            <template  v-slot:[`item.Size`]="{ item }">
              <td v-if="item.Size">
                {{ Object.values(item.Size)[0] }}
              </td>
            </template>
            <template v-slot:[`item.Reasons`]="{ item }">
              <v-sheet color="error" class="basic--text">
                <td>
                  <span v-for="(reason, i) in item.Reasons" :key="i">
                    <span v-if="item.Reasons.length - 1 == i">
                      {{ reason }}
                    </span>
                    <span v-else> {{ reason }}, </span>
                  </span>
                </td>
              </v-sheet>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <td>
                <v-btn
                  small
                  outlined
                  color="secondary"
                  @click="openProductForm(item)"
                  >Edit <v-icon right>mdi-circle-edit-outline</v-icon></v-btn
                >
              </td>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <ProductInfo :product="item"></ProductInfo>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="1"
          ><v-btn outlined color="success" @click="getProductsForUpload"
            >Next <v-icon right>mdi-arrow-right-bold-outline</v-icon></v-btn
          ></v-col
        >
      </v-row>
    </div>

    <ProductDialog
      v-if="showProductForm"
      :product="product"
      :title="title"
      :type="type"
      :fillDynamic="true"
      :excludeKeys="[]"
      @closeDialog="closeDialog"
      @closedStatusDialog="closedStatusDialog"
      @hideTable="showProductsToFix = false"
    ></ProductDialog>
  </div>
</template>

<script>
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductDialog from "../ProductDialog/ProductDialog.vue";

export default {
  name: "ProductsToFix",
  props: {
    products: Array,
  },
  components: {
    ProductInfo,
    ProductDialog,
  },
  data: () => ({
    headers: [
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "Photo", value: "Photos", class: "footer" },
      { text: "Category", value: "Category", class: "footer" },
      { text: "Style code", value: "StyleCode", class: "footer" },
      { text: "Style name", value: "StyleName", class: "footer" },
      {
        text: "Manufacturer color",
        value: "ManufacturerColor",
        class: "footer",
      },
      { text: "Real color", value: "RealColor", class: "footer" },
      { text: "Size", value: "Size", class: "footer" },
      { text: "Reasons", value: "Reasons", class: "footer" },
      { text: "Edit", value: "actions", class: "footer" },
    ],
    expanded: [],
    showProductForm: false,
    showProductsToFix: true,
    product: "",
    title: "",
    type: "",
  }),
  computed: {},
  mounted() {
    console.log(this.products[0].Photos);
  },
  methods: {
    openProductForm(product) {
      this.showProductsToFix = true;
      this.product = product;

      this.title = `Update ${product.SKU} for platform upload`;
      this.type = "resolvePlatform";

      this.showProductForm = true;
    },
    closedStatusDialog() {
      this.showProductsToFix = true;
      this.$emit("getProductsToFix");
    },
    refreshData() {
      this.showProductsToFix = true;
      this.$emit("getProductsToFix");
    },
    getProductsForUpload() {
      this.$emit("getProductsForUpload");
    },
    closeDialog() {
      this.showProductForm = false;
    },
  },
};
</script>